setTimeout(function() { console.log("timeout function");

  corner.on("onCartEdit", (params) => {
    // infoUpdate();

    var editDetails = params.cartEdits[0].eventType;
    var variantDeleted = params.cartEdits[0].eventDetails.variantId;

    if(editDetails == "ITEM_DELETED") {
      itemDeleteWithNote(variantDeleted);
    } else {
      infoUpdate();
    }
  });

  corner.on("refreshCart", (params) => {
    infoUpdate();
  });

  corner.on("onCowiOpen", (params) => {
    infoUpdate();
  });                       

  function infoUpdate() {
    var cartInfo = corner.get("cartInfo");
    
    $.each(cartInfo.items, function(k, v) { 
      var tags = v.tags;
      var product_id = v.productId;
      if($("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-qty span.param").length <= 0)
      if (tags.indexOf("sheet-tiles") != -1) {
        // console.log($("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-qty span.param").length);
        $("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-variant-options").hide(); //, [data-product-id= "+product_id+" ] .corner-cowi-cart-item-line-properties
        $("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-qty span").append("<span class='param'> Sheet</span>");
      } else if (tags.indexOf("tiles") != -1) {
        // console.log($("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-qty span.param").length);
        $("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-variant-options").hide();
        $("[data-product-id= "+product_id+" ] .corner-cowi-cart-item-qty span").append("<span class='param'> Box</span>");
      }
      
    });
  }

  function itemDeleteWithNote(variantDeleted) {
    var cartInfo = corner.get("cartInfo");
    
    $.each(cartInfo.items, function(k, v) { 
      var order_group = v.properties._io_parent_order_group;
      if (variantDeleted == v.variantId) {

        if(order_group != null && order_group != undefined && order_group != "")
        {
          // console.log("Variant attached with parent product");

          window.showCornerCartModal({
            title: "Please Note",
            description: "The product you have removed was part of a vanity options. Please note you won't get the removed product with your order.",
            isClosable: true,
            primaryCta: {
              text: "Got that!"
              // ,action: () => {
                // Code to remove items
                // refreshCart();
                // Close the modal manually when done
                // nav.cowiOverlay.set(null);
              // }
            }
            // ,secondaryCta: {
            //   text: "Got that!"
            // }
          });
        }

      }
    });
  }

}, 5000);